module.exports = __webpack_public_path__ + "img/PROGRAM_REJECTED.60217b55.svg";